import type { Transaction } from "@rocicorp/zero";
import * as z from "zod";
import type { Schema } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const resetOAuthConnectionSchema = z.object({
  oauthConnectionId: z.string(),
});

export const resetOAuthConnection = mutator({
  schema: resetOAuthConnectionSchema,
  resolve: {
    connection: { kind: "oauthConnection", from: "oauthConnectionId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.connection.connectedApps?.[0]?.id ?? "",
    },
  ],
  fn: async ({ tx, args: { connection } }) => {
    await disconnectOAuthConnection(tx, connection.id);
  },
});

export async function disconnectOAuthConnection(
  tx: Pick<Transaction<Schema>, "mutate">,
  id: string
) {
  await tx.mutate.oauthConnections.update({
    id,
    status: "not_connected",
    tokenType: null,
    accessTokenExpiresAt: null,
    refreshTokenExpiresAt: null,
    lastError: null,
    authorizedByUserId: null,
    updatedAt: Date.now(),
  });
}
